// https://css-tricks.com/responsive-data-tables/
// https://medium.com/@sak1986/create-mobile-friendly-tables-easily-16a1f6bb0b13
S.table =
    {
        init()
        {
            this.copyTableHeaders();
        },

        copyTableHeaders()
        {
            let tableHead;
            let i;
            const data = [];

            // push headlines in array
            this.$module.find('th').each(function ()
            {
                data.push($(this).text());
            });

            for (i = 0; i < data.length; ++i)
            {
                tableHead = '<span>' + data[i] + '</span>';
                this.$module.find('tbody tr td:nth-child(' + (i + 1) + ')').prepend(tableHead);
            }
        },
    };
